{
  "public.detail": {
    "search.placeholder": "Search shortlist",
    "hero.shortlistBy": "Shortlist by {{name}}",
    "empty.title": "No one shortlisted",
    "empty.description": "Build your shortlist by selecting resources to present to stakeholders",
    "filters.label": "Filters",
    "item.emptyValue": "n/a",
    "passwordProtection": {
      "enterPassword": "Enter password to view shortlist",
      "placeholder": "Enter password",
      "viewShortlist": "View Shortlist"
    },
    "error": {
      "title": "Error searching shortlist"
    }
  },
  "GenericSearchFilterItem": {
    "filters": {
      "belongsToMe": "Belongs to me",
      "createdAt": "Created after {{date}}",
      "publishedOnly": "Published Only",
      "draftOnly": "Draft Only",
      "archived": "Show Archived",
      "contactId": "Resource {{contact}}",
      "between": "Between {{startDate}} - {{endDate}}",
      "tags": {
        "and": " and ",
        "more": " more",
        "any": "Any tag: {{tag}}",
        "match": "Match tags: {{tags}}"
      }
    }
  },
  "GridViewItemGallery": {
    "editGallery": "Edit Gallery",
    "emptyGalleryTitle": "Empty gallery",
    "emptyGalleryDescription": "Add media for this resource",
    "addMedia": "Add media"
  },
  "ShortlistVotes": {
    "upvote": "Upvote",
    "downvote": "Downvote",
    "saveFailed": "Couldn't save your vote. Try again."
  },
  "ShortlistMediaSidebarPage": {
    "draft": "Draft",
    "votingDisabled": "Voting is disabled when the shortlist is not published",
    "commentingDisabled": "Commenting is disabled when the shortlist is not published",
    "votingAndCommentingDisabled": "Voting and commenting are disabled when the shortlist is not published"
  },
  "MediaSidebar": {
    "Header": {
      "shortlistedCount": "Shortlisted {{count}} of {{totalBlocks}}",
      "previous": "Previous shortlisted",
      "next": "Next shortlisted"
    },
    "CommentList": {
      "label": "Comments",
      "guest": "Guest",
      "noComments": "No comments yet",
      "startConversation": "Be the first to share what you think about {{name}}.",
      "startConversationNoName": "Share what you think about this person with your team.",
      "commentsOff": "Comments are turned off"
    },
    "CommentInput": {
      "writeComment": "Write a comment",
      "addComment": "Add Comment",
      "writeFirstComment": "Write the first comment",
      "sendFailed": "Couldn't send your comment. Try again."
    },
    "GuestNameChangeForm": {
      "title": "Guest Feedback",
      "description": "Enter your name below to leave feedback",
      "placeholder": "Your name",
      "saveChanges": "Save Changes"
    },
    "GuestInfo": {
      "youAre": "You are {{name}}",
      "change": "Change"
    },
    "Details": {
      "noFields": "This shortlist has no fields to show"
    },
    "Tabs": {
      "label": "Sections",
      "comments": "Comments",
      "details": "Details"
    }
  },
  "SetGuestNameModal": {
    "title": "Set a guest name",
    "description": "You need to tell the shortlist owner who you are before you can vote or comment on people in the shortlist",
    "yourName": "Your name",
    "saveName": "Save Name",
    "successfullyCreated": "Successfully created",
    "guestNameSet": "Guest name set"
  },
  "ShortlistCreateButton": {
    "create": "Create Shortlist"
  },
  "ShortlistCreateDialog": {
    "title": "Create shortlist",
    "description": "Name the new shortlist, describe it and tag it.",
    "titleLabel": "Title",
    "titlePlaceholder": "Shortlist title",
    "titleRequired": "Enter a title",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Shown to clients under the title",
    "tagsLabel": "Tags",
    "create": "Create"
  }
}
